module.exports = __webpack_public_path__ + "img/SNRG-alt.c7239915.svg";